/**
 *
 * @param {string} value The value to check
 * @returns {boolean}
 */
export const isUuid = (value: string) => {
  const uuidRegExp = /^[0-9a-f]{32}$/
  return uuidRegExp.test(value)
}
